import React, { useState, useEffect } from 'react';
import { FaBuilding, FaStore, FaUser, FaEnvelope, FaIdCard } from 'react-icons/fa';
import api from '../../config/axios';
import Swal from 'sweetalert2';

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [gestoraInfo, setGestoraInfo] = useState(null);
  const [unidadeInfo, setUnidadeInfo] = useState(null);

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    Swal.fire({
      title: "Carregando...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await api.get('/me');
      const userData = response.data;
      
      localStorage.setItem('userData', JSON.stringify(userData));
      
      setUserData(userData);

      if (userData.gestora) {
        setGestoraInfo({
          id: userData.gestora.id,
          nome: userData.gestora.nome
        });
      }

      if (userData.unidade) {
        setUnidadeInfo({
          id: userData.unidade.id,
          nome: userData.unidade.nome
        });
      }
    } catch (error) {
      console.error('Erro ao buscar informações do usuário:', error);
    } finally {
      Swal.close();
    }
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold mb-0">Dashboard</h4>
            </div>
          </div>

          <div className="row mt-4 g-4">
            {gestoraInfo && (
              <div className="col-lg-6 col-md-12">
                <div
                  className="card dashboard-card h-100"
                  style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0'
                  }}
                >
                  <div className="card-body d-flex align-items-center p-4">
                    <div style={{
                      backgroundColor: 'rgba(13, 110, 253, 0.1)',
                      width: '70px',
                      height: '70px',
                      minWidth: '70px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px'
                    }}>
                      <FaBuilding size={32} style={{ color: '#0d6efd' }} />
                    </div>
                    <div>
                      <p className="text-muted small mb-1">Gestora</p>
                      <h5 className="mb-0">{gestoraInfo.nome}</h5>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {unidadeInfo && (
              <div className="col-lg-6 col-md-12">
                <div
                  className="card dashboard-card h-100"
                  style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0'
                  }}
                >
                  <div className="card-body d-flex align-items-center p-4">
                    <div style={{
                      backgroundColor: 'rgba(25, 135, 84, 0.1)',
                      width: '70px',
                      height: '70px',
                      minWidth: '70px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '20px'
                    }}>
                      <FaStore size={32} style={{ color: '#198754' }} />
                    </div>
                    <div>
                      <p className="text-muted small mb-1">Unidade</p>
                      <h5 className="mb-0">{unidadeInfo.nome}</h5>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;